import React from 'react'
import Select from 'react-select'

class SingleAreaSelect extends React.Component {
  componentWillUnmount () {
    this.props.resetSearch()
  }

  handleChange (option) {
    this.props.onChange((option || {}).value)

    if (!option) {
      this.props.resetSearch()
    }
  }

  render () {
    return (
      <Select
        {...this.props}
        value={this.props.value || ''}
        onBlur={() => {}}
        onChange={(option) => this.handleChange(option)}
      />
    )
  }
}

export default SingleAreaSelect



// WEBPACK FOOTER //
// ./src/components/forms/single-area-select.js